import {React, observer} from '@api'
import {Tabs} from '@material-ui/core';
import {PictureAsPdfSharp} from '@material-ui/icons';
import {useStores} from '@modules'
import {globalStores} from '@stores'

import {LibrarySidebarTabs, LibrarySidebarTabsStyles, SidebarTab} from 'centric-ui-components'

const PdfSideBarTab = p => <SidebarTab {...p} title={'PDF'} icon={<PictureAsPdfSharp/>} />

export const PdfSidebarToolbarTabs = observer(function PdfSidebarToolbarTabs( ) {
  const {sidebar:{left, right}} = useStores()

  return <Tabs
    className={LibrarySidebarTabsStyles.tabs}
    value={right.open ? 0 : false}
    // To override and fix bad tab indicators being drawn at startup
    TabIndicatorProps={right.open ? {style: {left: 0, width: 60}} : undefined}
    onChange={right.toggleOpen}
  >
    <PdfSideBarTab />
  </Tabs>
})


// WEBPACK FOOTER //
// ./src/modules/pdf/PdfSidebarToolbarTab.tsx